<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
  >
    <path
      d="M10.7321 15C9.96225 16.3333 8.03775 16.3333 7.26795 15L0.339748 3C-0.430052 1.66667 0.5322 2.02535e-06 2.0718 2.15994e-06L15.9282 3.37131e-06C17.4678 3.5059e-06 18.4301 1.66667 17.6603 3L10.7321 15Z"
      fill="currentColor"
    />
  </svg>
</template>